import { createSvgIcon } from "@mui/material/utils";

/**
 * Staff icon.
 *
 * ![StaffIcon](data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSItMi44OCAtMi44OCAyOS43NiAyOS43NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHN0eWxlPSJiYWNrZ3JvdW5kOiNmZmY7Ym9yZGVyLXJhZGl1czo0cHgiPjxwYXRoIGQ9Ik0yMCAyMUMyMCAxOS42MDQ0IDIwIDE4LjkwNjcgMTkuODI3OCAxOC4zMzg5QzE5LjQ0IDE3LjA2MDUgMTguNDM5NSAxNi4wNiAxNy4xNjExIDE1LjY3MjJDMTYuNTkzMyAxNS41IDE1Ljg5NTYgMTUuNSAxNC41IDE1LjVIOS41QzguMTA0NDQgMTUuNSA3LjQwNjY1IDE1LjUgNi44Mzg4NiAxNS42NzIyQzUuNTYwNDUgMTYuMDYgNC41NjAwNCAxNy4wNjA1IDQuMTcyMjQgMTguMzM4OUM0IDE4LjkwNjcgNCAxOS42MDQ0IDQgMjFNMTYuNSA3LjVDMTYuNSA5Ljk4NTI4IDE0LjQ4NTMgMTIgMTIgMTJDOS41MTQ3MiAxMiA3LjUgOS45ODUyOCA3LjUgNy41QzcuNSA1LjAxNDcyIDkuNTE0NzIgMyAxMiAzQzE0LjQ4NTMgMyAxNi41IDUuMDE0NzIgMTYuNSA3LjVaIiBzdHJva2U9IiMxMDE4MjgiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48L3BhdGg+PC9zdmc+)
 */
const StaffIcon = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  "Staff"
);

export default StaffIcon;
